module.exports = __webpack_public_path__ + "static/media/HPV.676934f4.png";